import { selectors as authSelectors } from 'store/features/auth';
import { useSelector } from 'react-redux';

const usePermissions = () => {
  const permissions = useSelector(authSelectors.permissions);

  return permissions;
};

export default usePermissions;
